import React, { useCallback, useState } from 'react';
import classNames from 'classnames';
import { slugify } from '@kineticdata/react';
import { FormDropdown } from '../FormDropdown';
import { Icon } from '../Icon';

export const ColumnControl = ({ columns, renderOptions = {} }) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = useCallback(() => setIsOpen(o => !o), []);

  return (
    <FormDropdown isOpen={isOpen} toggle={toggle}>
      {({ FormDropdownToggle, FormDropdownMenu }) => (
        <>
          <FormDropdownToggle
            tag="button"
            type="button"
            className={classNames(
              {
                'btn btn-outline-primary': !renderOptions.columnControlClass,
                'btn-sm': renderOptions.columnControlSize === 'sm',
              },
              renderOptions.columnControlClass,
            )}
            aria-label="Columns"
            title="Columns"
          >
            <Icon name="settings" />
          </FormDropdownToggle>
          <FormDropdownMenu
            strategy="fixed"
            className="p-3"
            modifiers={[{ name: 'preventOverflow', enabled: true }]}
            end
          >
            <fieldset
              className="form-group m-0 wide-group"
              style={
                columns.size > 9
                  ? {
                      display: 'grid',
                      gridTemplateColumns: `repeat(${
                        columns.size > 18 ? 3 : 2
                      }, 1fr)`,
                      gridGap: '0 1rem',
                    }
                  : undefined
              }
            >
              <legend>Columns</legend>
              {columns.map(column => {
                const id = slugify(`column-${column.get('value')}`);
                return (
                  <div key={id} className="form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id={id}
                      checked={column.get('checked')}
                      disabled={!column.get('enabled')}
                      onChange={column.get('toggle')}
                    />
                    <label className="form-check-label" htmlFor={id}>
                      {column.get('label')}
                    </label>
                  </div>
                );
              })}
            </fieldset>
          </FormDropdownMenu>
        </>
      )}
    </FormDropdown>
  );
};
